<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="678px"
    custom-class="login-dialog"
    @close="handleClose"
  >
    <div class="close-btn" @click="dialogVisible = false">✕</div>

    <div class="login-content" :class="{ 'login-content--single': !allowWechat }" v-if="type == 'login'">
      <div v-if="allowSMS || allowPassword" class="login-left">
        <div v-if="allowSMS && allowPassword" class="tabs-header">
          <div
            class="tab-item"
            :class="{ active: activeTab === 'phone' }"
            @click="activeTab = 'phone'"
          >
            手机号登录
          </div>
          <div
            class="tab-item"
            :class="{ active: activeTab === 'account' }"
            @click="activeTab = 'account'"
          >
            账号登录
          </div>
        </div>
        <div v-if="allowSMS && activeTab === 'phone'">
          <input
            v-model="form.phone"
            placeholder="输入手机号码"
            maxlength="11"
            type="tel"
            inputmode="tel"
            name="tel"
            autocomplete="tel"
            data-allow-autofill="true"
            class="login-input"
          />
          <div class="code-row">
            <input
              v-model="form.code"
              placeholder="验证码"
              maxlength="6"
              type="text"
              inputmode="numeric"
              name="one-time-code"
              autocomplete="one-time-code"
              data-allow-autofill="true"
              class="code-input"
            />
            <button
              type="text"
              class="code-btn"
              :disabled="countDown > 0"
              @click="sendCode"
            >
              {{ countDown > 0 ? `${countDown}s后重发` : "获取验证码" }}
            </button>
          </div>
          <button type="primary" class="login-btn" @click="handleLogin">
            登录/注册
          </button>
        </div>
        <div v-if="allowPassword && activeTab === 'account'">
          <input
            v-model="form.account"
            placeholder="输入手机号/邮箱/用户名"
            name="username"
            autocomplete="username"
            data-allow-autofill="true"
            class="login-input"
            style="margin-bottom: 10px"
          />
          <div class="password-field">
            <input
              v-model="form.password"
              :type="showAccountPassword ? 'text' : 'password'"
              placeholder="输入密码"
              name="current-password"
              autocomplete="current-password"
              data-allow-autofill="true"
              class="login-input password-input"
            />
            <button
              type="button"
              class="password-toggle"
              @click="showAccountPassword = !showAccountPassword"
            >
              {{ showAccountPassword ? "隐藏" : "显示" }}
            </button>
          </div>
          <div class="zhuce">
            <div class="rememberMe">
              <el-checkbox v-model="form.rememberMe"></el-checkbox
              ><span>记住我</span>
            </div>
            <button type="button" class="password-help" @click="openResetDialog">
              忘记密码？
            </button>
          </div>
          <button type="primary" class="login-btn" @click="handleLogin">
            登录
          </button>
        </div>
      </div>
      <div v-if="allowWechat" class="login-right">
        <h3 class="login-title">微信扫码登录</h3>
        <div class="qrcode-box">
          <img
            v-if="wechatQRCodeURL"
            :src="wechatQRCodeURL"
            alt="微信扫码登录"
            class="wechat-qrcode-image"
          />
          <div v-else-if="showWechatPlaceholder" class="wechat-placeholder">
            {{ wechatPlaceholderText }}
          </div>
          <div v-else class="wechat-loading">
            正在加载微信二维码
          </div>
        </div>
        <div class="wechat-actions">
          <button type="button" class="wechat-action" @click="refreshWechatLogin">
            刷新二维码
          </button>
          <button
            type="button"
            class="wechat-action"
            :disabled="!wechatQRCodeURL"
            @click="openWechatLogin"
          >
            打开扫码页
          </button>
        </div>
      </div>
    </div>
    <div class="bindClass" v-if="type == 'bind'">
      <div class="bindTop">
        <h3>绑定你的手机号</h3>
        <!-- 返回按钮 -->
        <el-button class="backLogin" type="text" @click="returnToLogin"
          >返回</el-button
        >
      </div>
      <div class="phoneClass">
        <input
          v-model="form.phone"
          placeholder="输入手机号码"
          maxlength="11"
          type="tel"
          inputmode="tel"
          name="tel"
          autocomplete="tel"
          data-allow-autofill="true"
          class="login-input"
        />
        <div class="code-row">
          <input
            v-model="form.code"
            placeholder="验证码"
            maxlength="6"
            type="text"
            inputmode="numeric"
            name="one-time-code"
            autocomplete="one-time-code"
            data-allow-autofill="true"
            class="code-input"
          />
          <button
            type="text"
            class="code-btn"
            :disabled="countDown > 0"
            @click="sendCode"
          >
            {{ countDown > 0 ? `${countDown}s后重发` : "获取验证码" }}
          </button>
        </div>
        <button type="primary" class="login-btn" @click="handleLogin">
          完成绑定
        </button>
        <div class="xieyi">
          注册登录即代表已阅读并同意我们的
          <span>用户协议</span>与<span>隐私政策</span>
        </div>
      </div>
    </div>
    <div class="bindClass" v-if="type == 'reset'">
      <div v-if="resetStep == 1">
        <div class="bindTop">
          <h3>找回密码</h3>
          <!-- 返回按钮 -->
          <el-button class="backLogin" type="text" @click="returnToLogin">
            返回
          </el-button>
        </div>
        <div class="tip">输入您需要找回密码的账号</div>
        <div class="phoneClass" style="margin-top: 34px">
          <input
            v-model="resetForm.phone"
            placeholder="输入手机号码"
            maxlength="11"
            type="tel"
            inputmode="tel"
            name="tel"
            autocomplete="tel"
            data-allow-autofill="true"
            class="login-input"
          />
          <div class="code-row">
            <input
              v-model="resetForm.code"
              placeholder="验证码"
              maxlength="6"
              type="text"
              inputmode="numeric"
              name="one-time-code"
              autocomplete="one-time-code"
              data-allow-autofill="true"
              class="code-input"
            />
            <button
              type="text"
              class="code-btn"
              :disabled="countDown > 0"
              @click="sendCode"
            >
              {{ countDown > 0 ? `${countDown}s后重发` : "获取验证码" }}
            </button>
          </div>
          <button type="primary" class="login-btn" @click="handleLogin">
            下一步
          </button>
        </div>
      </div>
      <div v-if="resetStep == 2">
        <div class="bindTop">
          <h3>重置密码</h3>
          <!-- 返回按钮 -->
          <el-button class="backLogin" type="text" @click="resetStep = 1">
            返回
          </el-button>
        </div>
        <div class="tip">输入您账号的新密码</div>
        <div class="phoneClass" style="margin-top: 34px">
          <div class="password-field">
            <input
              v-model="resetForm.newPassword"
              placeholder="输入新的密码"
              :type="showResetPassword ? 'text' : 'password'"
              name="new-password"
              autocomplete="new-password"
              data-allow-autofill="true"
              class="login-input password-input"
            />
            <button
              type="button"
              class="password-toggle"
              @click="showResetPassword = !showResetPassword"
            >
              {{ showResetPassword ? "隐藏" : "显示" }}
            </button>
          </div>
          <div class="password-field">
            <input
              v-model="resetForm.confirmPassword"
              placeholder="确认密码"
              :type="showResetConfirmPassword ? 'text' : 'password'"
              name="new-password"
              autocomplete="new-password"
              data-allow-autofill="true"
              class="login-input password-input"
            />
            <button
              type="button"
              class="password-toggle"
              @click="showResetConfirmPassword = !showResetConfirmPassword"
            >
              {{ showResetConfirmPassword ? "隐藏" : "显示" }}
            </button>
          </div>
          <button type="primary" class="login-btn" @click="handleLogin">
            完成
          </button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  ApiError,
  buildAPIURL,
} from "@/services/api";
import {
  bindWechatPhone,
  checkWechatState,
  fetchWechatQRCode,
  loginWithPassword,
  loginWithSMS,
  resetPasswordBySMS,
  restoreSession,
  sendSMSCode,
} from "@/services/auth";
import { normalizeAllowedAuthMethods } from "@/services/platformOnboarding";
import {
  createWechatPollGuard,
  isVerifiedWechatLogin,
  shouldVerifyWechatSession,
} from "@/services/wechatLoginState";

const INVITE_CODE_STORAGE_KEY = "matrix_invite_code_v1";

export default {
  name: "LoginDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    allowedAuthMethods: {
      type: Array,
      default: () => ["password", "sms", "wechat"],
    },
  },
  data() {
    return {
      type: "login", // login - 登录，bind - 账号绑定，reset - 密码重置
      activeTab: "phone", // phone - 手机号登录， account - 账号密码登录
      resetStep: 1, // 密码重置步骤，1 - 输入手机号和验证码, 2 - 设置新密码
      form: {
        phone: "",
        code: "",
        account: "",
        password: "",
        rememberMe: false,
      },
      resetForm: {
        phone: "",
        code: "",
        newPassword: "",
        confirmPassword: "",
      },
      showAccountPassword: false,
      showResetPassword: false,
      showResetConfirmPassword: false,
      countDown: 0,
      timer: null,
      submitting: false,
      wechatState: "",
      wechatQRCodeURL: "",
      wechatPollTimer: null,
      wechatPollGuard: createWechatPollGuard(),
      showWechatPlaceholder: false,
      wechatPlaceholderText: "微信二维码加载失败",
      wechatTip: "使用微信扫码快捷登录",
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        this.captureInviteCodeFromRoute();
      },
    },
    dialogVisible(val) {
      if (val) {
        this.selectAllowedLoginTab();
        this.captureInviteCodeFromRoute();
        if (this.allowWechat) {
          this.refreshWechatLogin();
        }
      } else {
        this.stopWechatPolling();
      }
    },
    allowedAuthMethods: {
      deep: true,
      handler() {
        this.selectAllowedLoginTab();
        if (!this.allowWechat) {
          this.stopWechatPolling();
        }
      },
    },
    type(val) {
      if (val === "login" && this.dialogVisible) {
        this.$nextTick(() => {
          this.refreshWechatLogin();
        });
      }
    },
  },
  computed: {
    normalizedAllowedAuthMethods() {
      return normalizeAllowedAuthMethods(this.allowedAuthMethods);
    },
    allowPassword() {
      return this.normalizedAllowedAuthMethods.includes("password");
    },
    allowSMS() {
      return this.normalizedAllowedAuthMethods.includes("sms");
    },
    allowWechat() {
      return this.normalizedAllowedAuthMethods.includes("wechat");
    },
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    selectAllowedLoginTab() {
      if (this.activeTab === "phone" && this.allowSMS) {
        return;
      }
      if (this.activeTab === "account" && this.allowPassword) {
        return;
      }
      this.activeTab = this.allowSMS ? "phone" : "account";
    },
    getRouteInviteCode() {
      const query = (this.$route && this.$route.query) || {};
      const raw = query.invite_code || query.inviteCode || "";
      return String(raw || "").trim().toUpperCase();
    },
    captureInviteCodeFromRoute() {
      const inviteCode = this.getRouteInviteCode();
      if (!inviteCode) {
        return "";
      }
      try {
        window.localStorage.setItem(INVITE_CODE_STORAGE_KEY, inviteCode);
      } catch (error) {
        return inviteCode;
      }
      return inviteCode;
    },
    resolveInviteCode() {
      const routeInviteCode = this.captureInviteCodeFromRoute();
      if (routeInviteCode) {
        return routeInviteCode;
      }
      try {
        return String(window.localStorage.getItem(INVITE_CODE_STORAGE_KEY) || "").trim().toUpperCase();
      } catch (error) {
        return "";
      }
    },
    clearInviteCode() {
      try {
        window.localStorage.removeItem(INVITE_CODE_STORAGE_KEY);
      } catch (error) {
        return;
      }
    },
    async sendCode() {
      const phone =
        this.type === "reset" ? this.resetForm.phone : this.form.phone;
      let purpose = "login";
      const isWechatBind = this.type === "bind";
      const bindState = isWechatBind ? this.wechatState : "";
      const bindGeneration = isWechatBind ? this.wechatPollGuard.current() : 0;
      if (this.type === "reset") {
        purpose = "password_reset";
      } else if (isWechatBind) {
        purpose = "wechat_bind";
      }

      if (isWechatBind && !bindState) {
        this.$message.error("微信登录状态已失效，请刷新二维码后重试");
        return;
      }

      if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.$message.error("请输入正确的手机号码");
        return;
      }

      try {
        await sendSMSCode(phone, purpose, bindState);
        if (isWechatBind && (!this.wechatPollGuard.isCurrent(bindGeneration) || bindState !== this.wechatState)) {
          return;
        }
        this.startCountdown();
        this.$message.success("验证码已发送");
      } catch (error) {
        if (isWechatBind && (!this.wechatPollGuard.isCurrent(bindGeneration) || bindState !== this.wechatState)) {
          return;
        }
        this.$message.error(error.message || "验证码发送失败");
      }
    },
    startCountdown() {
      this.countDown = 60;
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.timer = setInterval(() => {
        if (this.countDown <= 0) {
          clearInterval(this.timer);
          this.timer = null;
          return;
        }
        this.countDown--;
      }, 1000);
    },
    async handleLogin() {
      if (this.submitting) {
        return;
      }

      try {
        this.submitting = true;

        if (this.type === "bind") {
          await this.handleWechatBind();
          return;
        }

        if (this.type === "reset") {
          await this.handleResetPassword();
          return;
        }

        if (this.activeTab === "account") {
          if (!this.form.account || !this.form.password) {
            this.$message.error("请输入账号和密码");
            return;
          }
          await loginWithPassword(
            this.form.account,
            this.form.password,
            this.form.rememberMe
          );
          this.$message.success("登录成功");
          this.clearInviteCode();
          this.$emit("success");
          this.dialogVisible = false;
          return;
        }

        if (!this.form.phone || !this.form.code) {
          this.$message.error("请输入手机号和验证码");
          return;
        }

        await loginWithSMS(this.form.phone, this.form.code, this.resolveInviteCode());
        this.$message.success("登录成功");
        this.clearInviteCode();
        this.$emit("success");
        this.dialogVisible = false;
      } catch (error) {
        if (error instanceof ApiError) {
          this.$message.error(error.message);
          return;
        }
        this.$message.error(error.message || "操作失败");
      } finally {
        this.submitting = false;
      }
    },
    async handleResetPassword() {
      if (this.resetStep === 1) {
        if (!this.resetForm.phone || !this.resetForm.code) {
          this.$message.error("请输入手机号和验证码");
          return;
        }
        this.resetStep = 2;
        return;
      }

      if (!this.resetForm.newPassword || !this.resetForm.confirmPassword) {
        this.$message.error("请输入并确认新密码");
        return;
      }
      if (this.resetForm.newPassword !== this.resetForm.confirmPassword) {
        this.$message.error("两次输入的密码不一致");
        return;
      }

      await resetPasswordBySMS(
        this.resetForm.phone,
        this.resetForm.code,
        this.resetForm.newPassword
      );
      this.$message.success("密码重置成功，请重新登录");
      this.type = "login";
      this.activeTab = "account";
      this.form.account = this.resetForm.phone;
      this.form.password = "";
      this.resetStep = 1;
      this.resetForm.newPassword = "";
      this.resetForm.confirmPassword = "";
      this.showResetPassword = false;
      this.showResetConfirmPassword = false;
    },
    async handleWechatBind() {
      if (!this.form.phone || !this.form.code) {
        this.$message.error("请输入手机号和验证码");
        return;
      }
      if (!this.wechatState) {
        this.$message.error("微信登录状态已失效，请刷新二维码后重试");
        return;
      }

      const state = this.wechatState;
      const generation = this.wechatPollGuard.current();
      const request = this.wechatPollGuard.beginRequest(generation);
      if (!request) {
        return;
      }
      let result;
      try {
        result = await bindWechatPhone(state, this.form.phone, this.form.code, this.resolveInviteCode(), { signal: request.signal });
      } catch (error) {
        if (!this.wechatPollGuard.isCurrent(generation) || error?.name === "AbortError") {
          return;
        }
        throw error;
      } finally {
        request.finish();
      }
      const { data, session } = result;
      if (!this.wechatPollGuard.isCurrent(generation) || state !== this.wechatState) {
        return;
      }
      if (!isVerifiedWechatLogin(data, session)) {
        this.showWechatPlaceholder = true;
        this.wechatQRCodeURL = "";
        this.wechatPlaceholderText = "未能确认绑定登录状态，请刷新二维码";
        this.$message.error("未能确认绑定登录状态，请刷新二维码");
        return;
      }
      this.$message.success("绑定成功，已自动登录");
      this.clearInviteCode();
      this.$emit("success");
      this.dialogVisible = false;
    },
    returnToLogin() {
      this.type = "login";
      this.resetStep = 1;
    },
    switchToPhoneLogin() {
      if (!this.allowSMS) {
        return;
      }
      this.type = "login";
      this.activeTab = "phone";
      this.$message.info("手机号验证码登录会自动完成注册或登录");
    },
    openResetDialog() {
      this.type = "reset";
      this.resetStep = 1;
    },
    async refreshWechatLogin() {
      if (!this.allowWechat) {
        this.stopWechatPolling();
        return;
      }
      const generation = this.stopWechatPolling();
      this.wechatState = "";
      this.wechatQRCodeURL = "";
      this.showWechatPlaceholder = false;
      try {
        const payload = await fetchWechatQRCode();
        if (!this.wechatPollGuard.isCurrent(generation) || !this.dialogVisible) {
          return;
        }
        const qrImageURL = payload && payload.qr_ticket
          ? buildAPIURL(`/api/v1/auth/wechat/qrcode/image?ticket=${encodeURIComponent(payload.qr_ticket)}`)
          : (payload && payload.qr_url ? payload.qr_url : "");
        if (payload && payload.state && qrImageURL) {
          this.wechatState = payload.state;
          this.wechatQRCodeURL = qrImageURL;
          this.showWechatPlaceholder = false;
          this.wechatPlaceholderText = "微信二维码加载失败";
          this.wechatTip = "请使用微信扫码登录";
          this.startWechatPolling(payload.state, generation);
          return;
        }
        throw new Error("微信二维码加载失败，请刷新重试");
      } catch (error) {
        if (!this.wechatPollGuard.isCurrent(generation)) {
          return;
        }
        this.wechatState = "";
        this.wechatQRCodeURL = "";
        this.showWechatPlaceholder = true;
        this.wechatPlaceholderText = error.message || "微信二维码加载失败";
        this.wechatTip = error.message || "微信二维码加载失败，请刷新重试";
      }
    },
    openWechatLogin() {
      if (!this.wechatQRCodeURL) {
        this.$message.warning("微信二维码尚未就绪");
        return;
      }
      window.open(this.wechatQRCodeURL, "_blank", "noopener,noreferrer");
    },
    startWechatPolling(state, generation) {
      if (!state || !this.wechatPollGuard.isCurrent(generation)) {
        this.showWechatPlaceholder = true;
        this.wechatPlaceholderText = "微信登录状态已失效，请刷新二维码";
        return;
      }
      const scheduleNext = () => {
        if (!this.wechatPollGuard.isCurrent(generation) || state !== this.wechatState) {
          return;
        }
        this.wechatPollTimer = setTimeout(poll, 2000);
      };
      const poll = async () => {
        this.wechatPollTimer = null;
        if (!this.wechatPollGuard.isCurrent(generation) || state !== this.wechatState) {
          return;
        }
        const request = this.wechatPollGuard.beginRequest(generation);
        if (!request) {
          return;
        }
        let continuePolling = true;
        try {
          const payload = await checkWechatState(state, { signal: request.signal });
          if (!this.wechatPollGuard.isCurrent(generation) || state !== this.wechatState) {
            return;
          }
          const status = payload && payload.data ? payload.data.status : "waiting";
          if (shouldVerifyWechatSession(payload && payload.data)) {
            continuePolling = false;
            const session = await restoreSession({ signal: request.signal });
            if (!this.wechatPollGuard.isCurrent(generation) || state !== this.wechatState) {
              return;
            }
            if (isVerifiedWechatLogin(payload.data, session)) {
              this.stopWechatPolling();
              this.$message.success("微信登录成功");
              this.clearInviteCode();
              this.$emit("success");
              this.dialogVisible = false;
            } else {
              this.stopWechatPolling();
              this.showWechatPlaceholder = true;
              this.wechatQRCodeURL = "";
              this.wechatPlaceholderText = "登录状态已失效，请刷新二维码";
              this.$message.error("未能确认登录状态，请刷新二维码");
            }
            return;
          }
          if (status === "scanned") {
            continuePolling = false;
            this.stopWechatPolling();
            this.type = "bind";
            this.$message.info("微信已扫码，请绑定手机号完成登录");
            return;
          }
          if (status === "error") {
            continuePolling = false;
            this.stopWechatPolling();
            this.showWechatPlaceholder = true;
            this.wechatQRCodeURL = "";
            this.wechatPlaceholderText = "微信登录状态异常，请刷新二维码";
            this.$message.error("微信登录状态异常，请刷新二维码");
          }
        } catch (error) {
          if (!this.wechatPollGuard.isCurrent(generation)) {
            return;
          }
          continuePolling = false;
          this.stopWechatPolling();
          this.showWechatPlaceholder = true;
          this.wechatQRCodeURL = "";
          this.wechatPlaceholderText = "微信二维码加载失败，请刷新重试";
        } finally {
          request.finish();
          if (continuePolling) {
            scheduleNext();
          }
        }
      };
      scheduleNext();
    },
    stopWechatPolling() {
      const generation = this.wechatPollGuard.invalidate();
      if (this.wechatPollTimer) {
        clearTimeout(this.wechatPollTimer);
        this.wechatPollTimer = null;
      }
      return generation;
    },
    handleClose() {
      this.type = "login";
      this.activeTab = this.allowSMS ? "phone" : "account";
      this.resetStep = 1;
      this.wechatTip = "使用微信扫码快捷登录";
      this.wechatState = "";
      this.wechatQRCodeURL = "";
      this.showWechatPlaceholder = false;
      this.wechatPlaceholderText = "微信二维码加载失败";
      this.form = {
        phone: "",
        code: "",
        account: "",
        password: "",
        rememberMe: false,
      };
      this.showAccountPassword = false;
      this.resetForm = {
        phone: "",
        code: "",
        newPassword: "",
        confirmPassword: "",
      };
      this.showResetPassword = false;
      this.showResetConfirmPassword = false;
      this.countDown = 0;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.stopWechatPolling();
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
    this.stopWechatPolling();
  },
};
</script>
<style lang="scss">
.login-dialog .el-dialog__header {
  display: none;
}

.login-dialog {
  .el-dialog__body {
    background-image: linear-gradient(
      -36deg,
      #ffe8db 7%,
      #fffcea 31%,
      #ffffff 100%
    ) !important;
  }
}
.login-dialog {
  border-radius: 12px !important;
  overflow: hidden;
  position: relative;
}

.login-dialog::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background-image: url("@/assets/image/doaLog.png");
  background-size: cover;
  border-radius: 12px 12px 0 0;
  z-index: 1;
}
</style>
<style lang="scss" scoped>
/* 自己写的关闭按钮 */
.close-btn {
  position: absolute;
  right: 20px;
  top: 15px;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
  font-weight: bold;
  z-index: 999;
}

.login-content {
  display: flex;

  border-radius: 12px;
  overflow: hidden;
}

.login-left {
  flex: 1;
  padding-top: 58px;
  padding-left: 22px;
  padding-right: 42px;
  margin: 0 0 42px;
  display: flex;
  flex-wrap: wrap;
  border-right: 1px solid #eee;
}

.login-content--single {
  justify-content: center;
}

.login-content--single .login-left {
  flex: 0 1 398px;
  border-right: none;
}

.login-input {
  height: 48px;
  border-radius: 2px;
  background-color: #f8f8f8;
  border: 1px solid #f8f8f8;
  width: 334px;
  padding: 0 16px;
  font-size: 14px;
}

.login-input:focus {
  outline: none;
  border-color: #ff8432;
  background-color: #fff;
  box-shadow: 0px 0px 12px 0px rgba(255, 145, 65, 0.4);
}

.password-field {
  position: relative;
  width: 334px;
  margin-bottom: 10px;
}

.password-input {
  width: 100%;
  padding-right: 68px;
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  border: none;
  background: none;
  color: #ff790c;
  font-size: 13px;
  cursor: pointer;
  padding: 0;
}
.code-row {
  margin-bottom: 35px;
  margin-top: 10px;
  height: 48px;
  border-radius: 2px;
  border: 1px solid #f8f8f8;
  background-color: #f8f8f8;
  width: 334px;
  padding: 0 16px;
  font-size: 14px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.code-input {
  flex: 1;
  background-color: #f8f8f8;
  margin-bottom: 0;
  font-size: 14px;
  border: none;
}

.code-row:focus-within {
  border-color: #ff8432;
  box-shadow: 0px 0px 12px 0px rgba(255, 145, 65, 0.4);
}
.code-input:focus {
  outline: none;
}

.code-btn {
  height: 22px;
  line-height: 22px;
  padding: 0;
  font-size: 14px;
  color: #ff790c;
  border: none;
  background: none;
  cursor: pointer;
  padding-left: 10px;
  border-left: 2px solid #cccccc;
}

.code-btn:disabled {
  color: #999;
  cursor: not-allowed;
}

.login-btn {
  width: 334px;
  height: 44px;
  line-height: 44px;
  font-size: 16px;
  color: #fff;
  font-weight: normal;
  border-radius: 20px;
  background-image: linear-gradient(96deg, #ff8514 0%, #ffa803 100%);
  border: none;
  box-shadow: 0px 10px 24px 0px rgba(255, 132, 0, 0.4);
}

.login-right {
  flex: 1;
  padding: 58px 50px 40px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
}

.login-title {
  font-size: 20px;
  font-weight: 500;
  color: #333;
  margin-bottom: 30px;
  width: 100%;
  text-align: center;
}

.qrcode-box {
  width: 180px;
  height: 180px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 8px 24px 0px rgba(255, 145, 65, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.wechat-qrcode-image {
  width: 160px;
  height: 160px;
  object-fit: contain;
  display: block;
}

.wechat-loading,
.wechat-placeholder {
  width: 160px;
  height: 160px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #999;
  font-size: 12px;
  line-height: 1.5;
  padding: 0 12px;
}

.wechat-loading {
  color: #999;
  font-size: 13px;
}

.wechat-actions {
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.wechat-action {
  border: none;
  background: none;
  color: #ff790c;
  cursor: pointer;
  font-size: 13px;
}

.wechat-action:disabled {
  color: #999;
  cursor: not-allowed;
}
/* 标签头部 */
.tabs-header {
  margin-bottom: 42px;
  display: flex;
  width: 100%;
}

/* 单个标签 */
.tab-item {
  margin: 0 20px;
  height: 32px;
  line-height: 32px;
  font-size: 18px;
  color: #888888;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
}

/* 选中样式 - 橙色下划线 */
.tab-item.active {
  color: #333333;
  font-weight: 600;
}
.tab-item.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 68px;
  height: 3px;
  background-color: #ff7d00;
  border-radius: 3px;
}
.xieyi {
  width: 336px;
  height: 12px;
  font-size: 12px;
  line-height: 70px;
  letter-spacing: 1px;
  color: #858080;
  span {
    font-size: 12px;
    letter-spacing: 1px;
    color: #ff790c;
  }
}
.zhuce {
  display: flex;
  align-items: center;
  height: 60px;
  justify-content: space-between;
  font-size: 14px;
  color: #999999;
  .password-help {
    border: none;
    background: transparent;
    color: #ff790c;
    cursor: pointer;
    font: inherit;
    padding: 0;
  }
  .rememberMe {
    display: flex;
    align-items: center;
    color: #999999;
    font-size: 13px;
    line-height: 1;
    cursor: pointer;
    span {
      margin-left: 7px;
      margin-top: -3px;
    }
  }
}
.bindClass {
  margin: 58px 15px 50px;
  .tip {
    text-align: center;
    font-size: 14px;
    letter-spacing: 0px;
    margin-top: 13px;
    color: #666666;
  }
  .phoneClass {
    margin: 48px auto 0;
    width: 332px;
  }
  .bindTop {
    text-align: center;
    position: relative;
    .backLogin {
      position: absolute;
      top: -15px;
      right: 0;
    }
    h3 {
      font-size: 20px;
      color: #333333;
    }
  }
}
</style>
